import { Component, Input, ViewChild, ViewContainerRef, Output, EventEmitter } from '@angular/core';
import { Tab } from '@shared/interfaces/nav-bar-ia.interfaces';

@Component({
  selector: 'app-so-tabs',
  template: '',
  styleUrls: [],
})
export class SoTabsBaseComponent{
  @Input() tabs: Tab[] = [];
  @Input() tabsDisplay: 'horizontal' | 'vertical' | 'sections' | 'steps' = 'horizontal';
  @Input() activeTabIndex: number = 0;
  @Input() type: 'simple' | 'principal' = 'simple';
  @Input() tabContentClass: string = '';
  @Input() tooltipDisabledText: string = '';
  @Input() contentCard: boolean = true;
  @Input() enableUnsavedDataCheck: boolean = false;
  @Input() contentTransparent: boolean = false;
  
  @Output() activeTabIndexChange = new EventEmitter<number>();

  @ViewChild('tabContainer', { read: ViewContainerRef, static: false }) tabContainer!: ViewContainerRef;

  setActiveTab(index: number): void {
    this.activeTabIndex = index;
    this.activeTabIndexChange.emit(this.activeTabIndex);
  }

  navigateToStep(route: string, index: number): void {
    this.activeTabIndex = index;
    this.activeTabIndexChange.emit(this.activeTabIndex);
  }

}